import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-hand-loader',
  templateUrl: './hand-loader.component.html',
  styleUrls: ['./hand-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
